export const POST_ALERT_SAVE_MOCK = {
  status: 'ok'
}